import React from "react";
import { SERVICE_TYPES, normalizeServiceType } from "@/lib/api";

const MAP = Object.fromEntries(SERVICE_TYPES.map((t) => [t.value, t]));

/**
 * Badge de tipo de servicio con color. Soporta valores legacy vía normalizeServiceType.
 * Props: value (string), compact (bool - versión pequeña).
 */
export default function ServiceTypeBadge({ value, compact = false, testid }) {
  const meta = MAP[normalizeServiceType(value)] || SERVICE_TYPES[0];
  return (
    <span
      data-testid={testid}
      className={`font-mono-kpi uppercase tracking-wider border inline-flex items-center ${compact ? "text-[9px] px-1 py-0" : "text-[10px] px-1.5 py-0.5"}`}
      style={{ color: meta.color, borderColor: `${meta.color}55`, background: `${meta.color}0d` }}
    >
      {meta.label}
    </span>
  );
}
